<template>
  <div class="layout">
    <el-container class="full-height">
      <el-aside width="200px" class="aside">
        <el-menu
          :default-active="$route.path"
          :default-openeds="openeds"
          router
          class="menu"
          background-color="#2d3a4b"
          text-color="#fff"
          active-text-color="#409EFF"
        >
          <MenuItem v-for="item in menus" :key="item.id" :item="item" />
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="title">后台管理系统</div>
          <div class="user">
            <el-dropdown>
              <span class="el-dropdown-link">
                管理员 <el-icon><arrow-down /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ArrowDown } from '@element-plus/icons-vue'
import MenuItem from '../components/MenuItem.vue'
import store from '../store'
import request from '../utils/request'

const router = useRouter()
const menus = ref([])
const openeds = ref([])


const getOpenedsByPath = (list, path) => {
  const stack = []
  const traverse = (items) => {
    for (const it of items) {
      if (it.path === path) {
        return true
      }
      if (it.children.length && traverse(it.children)) {
        stack.unshift(String(it.id))
        return true
      }
    }
    return false
  }
  traverse(list)
  return stack
}


const loadMenus = async () => {
  try {
    const data = await request.get('/v1/admin/menu')
    menus.value = data
    openeds.value = getOpenedsByPath(menus.value, router.currentRoute.value.path)
  } catch (e) {
    console.error(e)
  }
}

const logout = () => {
  store.dispatch('logout')
  router.push('/login')
}

onMounted(loadMenus)

watch(
  () => router.currentRoute.value.path,
  (p) => {
    openeds.value = getOpenedsByPath(menus.value, p)
  }
)
</script>

<style scoped>
.layout {
  height: 100vh;
}
.full-height {
  height: 100%;
}
.aside {
  background-color: #2d3a4b;
  color: #fff;
}
.header {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.title {
  font-size: 18px;
  font-weight: 600;
}
.main {
  padding: 20px;
}
.menu :deep(.el-menu-item.is-active) {
  background-color: #409EFF;
  color: #fff;
}
.submenu-title {
  display: flex;
  align-items: center;
}
.submenu-title .el-icon,
.menu :deep(.el-menu-item .el-icon) {
  margin-right: 4px;
}
</style>
